import { RESOURCE } from "../../../../routes/const";

export default () => [
  {
    action: "manage",
    subject: RESOURCE.creative.main,
  },
];
